<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="dialog"
      persistent
      :fullscreen="iOS && inIframe"
      max-width="768"
    >
      <v-card>
        <v-card-title
          class="title-name white--text"
          :style="dialogHeaderStyle"
        >{{ $t('select_dining_mode') }}</v-card-title>
        <v-divider></v-divider>
        <v-layout
          row
          justify-center
          wrap
        >
          <template>
            <v-container grid-list-sm text-xs-center>
              <v-layout
                row
                justify-center
              >
                <v-card
                  v-for="m in allModes"
                  :key="m.index"
                  hover
                  @click="changeModeArea(m)"
                >
                  <v-img
                    :style="imgSize"
                    :src="imgSrc(m)"
                  />
                  <v-card-title class="justify-center" :style="imgTitle">{{ m.name }}</v-card-title>
                </v-card>
              </v-layout>
            </v-container>
          </template>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'dining-mode-dialog2',
    computed: {
      ...mapGetters('config', [
        'theme', 'iOS', 'inIframe', 'colors', 'modes', 'modeSelected'
      ]),
      ...mapGetters('area', [
        'selectedAreaMode', 'selectedArea', 'isExpo'
      ]),
      imgSize () {
        return {
          height: '90px',
          width: '90px'
        };
      },
      imgTitle() {
        return {
          fontWeight: 'bold',
          padding: '0 10px 0 10px'
        }
      },
      dialog () {
        return (!this.selectedAreaMode && (!this.isExpo || this.areaListMode))
      },
      dialogHeaderStyle () {
        return {
          background: "#000000"
        }
      },
      allModes() {
        let allModes = []
        if(this.selectedArea.dine_in) allModes.push({ mode:'Dine In', name: (this.selectedArea.dinein_label === null || this.selectedArea.dinein_label === '' ) ? 'Dine In' : this.selectedArea.dinein_label })
        if(this.selectedArea.takeaway) allModes.push({mode:'Takeaway', name: (this.selectedArea.takeaway_label === null || this.selectedArea.takeaway_label === '') ? 'Takeaway' : this.selectedArea.takeaway_label })
        if(this.selectedArea.delivery) allModes.push({mode:'Delivery', name: (this.selectedArea.delivery_label === null || this.selectedArea.delivery_label === '') ? 'Delivery' : this.selectedArea.delivery_label })
        if (allModes.length === 0) allModes = [{ mode:'Takeaway', name: 'Takeaway' }, { mode:'Delivery', name: 'Delivery' }]
        const m = []
        allModes.forEach((item, index) => {
          const m1 = {
            index: index,
            isDinein: item.mode === 'Dine In',
            isTakeaway: item.mode === 'Takeaway',
            isDelivery: item.mode === 'Delivery',
            name: item.name,
            cats: 'all',
            hasPresetDiscount: false,
            presetDiscount: {
              discount_id: '',
              discount_name: '',
              discount_amount: '',
              discount_type: '',
              non_discount: ''
            },
            paymentMode: item.mode === 'Dine In' ? 0 : null
          }
          m.push(m1)
        })
        return m
      }
    },
    methods: {
      imgSrc (mode) {
        let imgName = '';
        if (mode.isDinein) imgName = 'dine_in'
        if (mode.isTakeaway) imgName = 'take_away'
        if (mode.isDelivery) imgName = 'delivery'
        return window.config.sharedPictures + imgName + '.png'
      },
      async changeModeArea (mode) {
        this.menu = false
        await this.$store.dispatch('area/setSelectedAreaMode', mode)
        if (!mode.isDinein) await this.$store.dispatch('area/showPostalCodeDialog')
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/DiningModelDialog2.vue